<template>
  <div class="wg-row">
    <wg-modal 
        :width="windowWidth > 900 ? '900px' : '90%'" 
        v-if="showVariationsDialog" 
        @closeModal="showVariationsDialog = false">
      <div class="com-anm22-app-text-xl" slot="header">
        {{ $anm22.strLang(lang, 'Variations', 'Variazioni')}}
      </div>
      <div class="wg-row" slot="body">
        <div class="wg-row">
          <div class="wg-col wg-xs-12 wg-sm-6" style="padding:0 10px 0 0;">
            <div class="wg-row" style="justify-content:center;">
              <div class="com-anm22-app-text-xl" style="padding:0 2px;">
                {{ $anm22.strLang(lang, 'List', 'Lista') }}
              </div>
            </div>
            <div class="vertical-height-div" style="height:10px;"></div>
            <div 
                v-for="(v,i) in categoryRef.variations"
                :key="'cat-var-'+i"
                class="wg-row"
                style="flex-wrap:nowrap;align-items:center;margin-bottom:10px;height:36px;">
              <img 
                  :src="$anm22.icons.getWorldIcon('deleteBlack')"
                  class="com-anm22-app-img-fixed-height-m" 
                  @click="deleteVariation(i)"
                  style="margin-right:10px;cursor:pointer;"
              >
              <div class="com-anm22-app-text-l">
                {{ 
                  v.it + (v.en ? (', ' + v.en) : '')+ (v.de ? (', ' + v.de) : '') + (v.fr ? (', ' + v.fr) : '')
                    + (v.es ? (', ' + v.es) : '') + (v.ru ? (', ' + v.ru) : '')
                }}
              </div>
              <div class="com-anm22-app-text-l" style="margin-left:auto;">
                {{ v.price.toFixed(2) + ' €'}}
              </div>
            </div>
          </div>
          <div class="wg-col wg-xs-12 wg-sm-6" style="padding:0 0 0 10px;">
            <div class="wg-row" style="justify-content:center;">
              <div class="com-anm22-app-text-xl" style="padding:0 2px;">
                {{ $anm22.strLang(lang, 'New', 'Nuova') }}
              </div>
            </div>
            <template v-if="varError">
              <div class="vertical-height-div" style="height:10px;"></div>
              <div class="wg-row com-anm22-app-text-m" style="color:red;">
                {{ varError }}
              </div>
            </template>
            <div class="vertical-height-div" style="height:10px;"></div>
            <div class="wg-row" style="flex-wrap:nowrap;align-items:center;justify-content:space-between;">
              <div class="com-anm22-app-text-l">
                {{ $anm22.strLang(lang, 'Text', 'Testo') + ' IT' }}
              </div>
              <input 
                  class="com-anm22-app-input-text"
                  style="max-width:70%;"
                  type="text"
                  :placeholder="$anm22.strLang(lang, 'Text', 'Testo')"
                  v-model="variation.it"> 
            </div>
            <div class="vertical-height-div" style="height:10px;"></div>
            <div class="wg-row" style="flex-wrap:nowrap;align-items:center;justify-content:space-between;">
              <div class="com-anm22-app-text-l">
                {{ $anm22.strLang(lang, 'Text', 'Testo') + ' EN' }}
              </div>
              <input 
                  class="com-anm22-app-input-text"
                  style="max-width:70%;"
                  type="text"
                  :placeholder="$anm22.strLang(lang, 'Text', 'Testo')"
                  v-model="variation.en"> 
            </div>
            <div class="vertical-height-div" style="height:10px;"></div>
            <div class="wg-row" style="flex-wrap:nowrap;align-items:center;justify-content:space-between;">
              <div class="com-anm22-app-text-l">
                {{ $anm22.strLang(lang, 'Text', 'Testo') + ' DE' }}
              </div>
              <input 
                  class="com-anm22-app-input-text"
                  style="max-width:70%;"
                  type="text"
                  :placeholder="$anm22.strLang(lang, 'Text', 'Testo')"
                  v-model="variation.de"> 
            </div>
            <div class="vertical-height-div" style="height:10px;"></div>
            <div class="wg-row" style="flex-wrap:nowrap;align-items:center;justify-content:space-between;">
              <div class="com-anm22-app-text-l">
                {{ $anm22.strLang(lang, 'Text', 'Testo') + ' FR' }}
              </div>
              <input 
                  class="com-anm22-app-input-text"
                  style="max-width:70%;"
                  type="text"
                  :placeholder="$anm22.strLang(lang, 'Text', 'Testo')"
                  v-model="variation.fr"> 
            </div>
            <div class="vertical-height-div" style="height:10px;"></div>
            <div class="wg-row" style="flex-wrap:nowrap;align-items:center;justify-content:space-between;">
              <div class="com-anm22-app-text-l">
                {{ $anm22.strLang(lang, 'Text', 'Testo') + ' ES' }}
              </div>
              <input 
                  class="com-anm22-app-input-text"
                  style="max-width:70%;"
                  type="text"
                  :placeholder="$anm22.strLang(lang, 'Text', 'Testo')"
                  v-model="variation.es"> 
            </div>
            <div class="vertical-height-div" style="height:10px;"></div>
            <div class="wg-row" style="flex-wrap:nowrap;align-items:center;justify-content:space-between;">
              <div class="com-anm22-app-text-l">
                {{ $anm22.strLang(lang, 'Text', 'Testo') + ' RU' }}
              </div>
              <input 
                  class="com-anm22-app-input-text"
                  style="max-width:70%;"
                  type="text"
                  :placeholder="$anm22.strLang(lang, 'Text', 'Testo')"
                  v-model="variation.ru"> 
            </div>
            <div class="vertical-height-div" style="height:10px;"></div>
            <div class="wg-row" style="flex-wrap:nowrap;align-items:center;justify-content:space-between;">
              <div class="com-anm22-app-text-l">
                {{ $anm22.strLang(lang, 'Price', 'Prezzo') + ' [€]' }}
              </div>
              <input 
                  class="com-anm22-app-input-number"
                  style="max-width:100px;"
                  type="number"
                  :placeholder="$anm22.strLang(lang, 'Price', 'Prezzo')"
                  v-model.number="variation.price">   
            </div>
            <div class="vertical-height-div" style="height:10px;"></div>
            <div class="wg-row" style="justify-content:center;">
            <input 
                type="button" 
                :value="$anm22.strLang(lang, 'Add', 'Aggiungi')" 
                @click="addVariation">
            </div>
          </div>
        </div>
      </div>
    </wg-modal>
    <!-- ICON MODAL -->
    <wg-modal 
        :width="windowWidth > 600 ? '600px' : '90%'" 
        v-if="showIconDialog" 
        @closeModal="showIconDialog = false">
      <div class="com-anm22-app-text-xl" slot="header">
        {{ $anm22.strLang(lang, 'Choose icon', 'Seleziona icona')}}
      </div>
      <div class="wg-row" slot="body" style="justify-content:center;">
        <!-- Lista icone -->
        <div 
            v-for="(url,name,i) in icons"
            :key="'icon-'+i"
            :class="['icon-div', icon === name ? 'selected' : '']"
            @click="icon = name">
          <img class="com-anm22-app-img-l" :src="$anm22.getImagePath(url)">
        </div>
        <div class="wg-row" style="justify-content:center;">
          <input 
              type="button" 
              :value="$anm22.strLang(lang, 'Confirm', 'Conferma')" 
              @click="setIcon">
        </div>
      </div>
    </wg-modal>
    <!-- COLOR MODAL -->
    <wg-modal 
        :width="windowWidth > 400 ? '400px' : '90%'" 
        v-if="showColorDialog" 
        @closeModal="showColorDialog = false">
      <div class="com-anm22-app-text-xl" slot="header">
        {{ $anm22.strLang(lang, 'Choose color', 'Seleziona colore')}}
      </div>
      <div class="wg-row" slot="body">
        <!-- Lista colori -->
        <div 
            v-for="(col, i) in colors"
            :key="'color-'+i"
            :class="['wg-row', 'color-div', col === color ? 'selected' : '']"
            @click="color = col">
          <div :style="{backgroundColor: col}"></div>
        </div>
        <div class="wg-row" style="justify-content:center;">
          <input 
              type="button" 
              :value="$anm22.strLang(lang, 'Confirm', 'Conferma')" 
              @click="setColor">
        </div>
      </div>
    </wg-modal>
    <!-- Tasti modali secondari -->
    <div v-if="categoryRef.id"  class="wg-row" style="flex-wrap:nowrap;align-items:center;justify-content:space-around;">
      <input 
          type="button" 
          :value="$anm22.strLang(lang, 'Variations', 'Variazioni')" 
          @click="showVariationsDialog = true">
      <input 
          type="button" 
          :value="$anm22.strLang(lang, 'Icon', 'Icona')" 
          @click="openIconModal">
      <input 
          type="button" 
          :value="$anm22.strLang(lang, 'Color', 'Colore')" 
          @click="openColorModal">
    </div>
    <div class="vertical-height-div" style="height:10px;"></div>
    <div class="wg-row">
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="com-anm22-app-text-l" style="padding:0 2px;">
          {{ $anm22.strLang(lang, 'Default VAT', 'IVA standard') }}
        </div>
        <div class="vertical-height-div" style="height:5px;"></div>
        <input 
            class="com-anm22-app-input-number"
            style="max-width:100%;"
            type="number"
            min="0"
            step="0.01"
            :placeholder="$anm22.strLang(lang, 'Default VAT', 'IVA standard')"
            v-model="category.defaultVat">  
      </div>
    </div>
    <div class="vertical-height-div" style="height:10px;"></div>
    <div class="wg-row">
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="com-anm22-app-text-l" style="padding:0 2px;">
          {{ $anm22.strLang(lang, 'Name', 'Nome') }}
        </div>
        <div class="vertical-height-div" style="height:5px;"></div>
        <input 
            class="com-anm22-app-input-text"
            style="max-width:100%;"
            type="text"
            :placeholder="$anm22.strLang(lang, 'Name', 'Nome')"
            v-model="category.name">   
      </div>
    </div>
    <template v-for="(l,i) in languages">
      <div :key="'lang-s1-'+i" class="vertical-height-div" style="height:10px;"></div>
      <div :key="'lang-title-'+i" class="wg-row">
        <div class="com-anm22-app-text-l" style="padding:0 2px;">
          {{ l.toUpperCase() }}
        </div>
      </div>
      <div :key="'lang-s2-'+i" class="vertical-height-div" style="height:10px;"></div>
      <div :key="'lang-input-'+i" class="wg-row">
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="com-anm22-app-text-l" style="padding:0 2px;">
            {{ $anm22.strLang(lang, 'Name', 'Nome') }}
          </div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <input 
              class="com-anm22-app-input-text"
              style="max-width:100%;"
              type="text"
              :placeholder="$anm22.strLang(lang, 'Name', 'Nome')"
              v-model="category['name'+$anm22.capitalizeFirst(l)]">   
        </div>
      </div>
    </template>
    <div class="vertical-height-div" style="height:10px;"></div>
    <div class="wg-row">
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="com-anm22-app-text-l" style="padding:0 2px;">
          {{ $anm22.strLang(lang, 'Set a sub category', 'Imposta come sottocategoria') }}
        </div>
        <div class="vertical-height-div" style="height:5px;"></div>
        <select class="com-anm22-app-select" v-model="category.parent" style="max-width:100%;">
          <option default :value="0">{{ $anm22.strLang(lang, 'No', 'No') }}</option>
          <option 
              v-for="(c,i) in categories.filter(c => !c.parent && c.id !== category.id)"
              :key="'cat-'+i"
              :value="c.id">
            {{ c.langName }}
          </option>
        </select>
      </div>
    </div>
    <div class="vertical-height-div" style="height:10px;"></div>
    <div class="wg-row">
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="com-anm22-app-text-l" style="padding:0 2px;">
          {{ $anm22.strLang(lang, 'Visible', 'Visibile') }}
        </div>
        <div class="vertical-height-div" style="height:5px;"></div>
        <input 
            id="visible"
            type="checkbox"
            style="display:none;"
            v-model="category.visible">
        <label class="label-input-radio" for="visible">
          {{ category.visible ? '✔' : '' }}
        </label>
      </div>
    </div>
    <div class="vertical-height-div" style="height:10px;"></div>
    <div class="wg-row">
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="com-anm22-app-text-l" style="padding:0 2px;">
          {{ $anm22.strLang(lang, 'Visible by customers', 'Visibile ai clienti') }}
        </div>
        <div class="vertical-height-div" style="height:5px;"></div>
        <input 
            id="visibleByCustomer"
            type="checkbox"
            style="display:none;"
            v-model="category.visibleByCustomer">
        <label class="label-input-radio" for="visibleByCustomer">
          {{ category.visibleByCustomer ? '✔' : '' }}
        </label>
      </div>
    </div>
    <template v-if="license.config.modules.sequences.enabled">
      <div class="vertical-height-div" style="height:10px;"></div>
      <div class="wg-row">
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="com-anm22-app-text-l" style="padding:0 2px;">
            {{ $anm22.strLang(lang, 'Enable order limits', 'Abilita limitazione ordini') }}
          </div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <input 
              id="tracking"
              type="checkbox"
              style="display:none;"
              v-model="category.limited">
          <label class="label-input-radio" for="tracking">
            {{ category.limited ? '✔' : '' }}
          </label>
        </div>
      </div>
      <div class="vertical-height-div" style="height:10px;"></div>
      <!-- Shifts and order tracking -->
      <div v-if="category.limited" class="wg-row">
        <div class="com-anm22-app-text-xl" style="font-weight:bold;">
          {{ $anm22.strLang(lang, 'Shifts Management', 'Gestione turni') }}
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div
            v-for="(weekDay) in [0,1,2,3,4,5,6]"
            :key="'shifts-weekDay-'+weekDay"
            class="wg-row" style="align-items:center;">
          <div class="wg-row">
            <div class="com-anm22-app-text-l">
              {{ $anm22.tableClasses.worldWeekDay().getById(weekDay+1)[lang] }}
            </div>
          </div>
          <div 
              v-if="!license.shifts[weekDay]"
              class="wg-row"
          >
            {{ $anm22.strLang(lang, 'No shifts set for this day', 'Nessun turno impostato per questo giorno') }}
          </div>
          <div 
              v-else
              v-for="(shift, j) in license.shifts[weekDay]"
              :key="'shift-'+weekDay+'-'+j"
              class="wg-row"
              style="align-items:center;"
          >
            <div class="wg-col wg-xs-12 wg-sm-3" style="padding:10px 10px 0 0;">
              <div class="wg-row" style="flex-direction:column;flex-wrap:nowrap;">
                <div class="com-anm22-app-text-l">
                  {{ $anm22.strLang(lang, 'Shift ', 'Turno ') + (j + 1) }}
                </div>
                <div class="com-anm22-app-text-m">
                  {{ $anm22.strLang(lang, 'From ', 'Da ') + shift.from + $anm22.strLang(lang, ' To ', ' A ') + shift.to }}
                </div>
              </div>
            </div>
            <div class="wg-col wg-xs-12 wg-sm-9" style="padding:10px 10px 0 0;">
              <div 
                v-if="!category.shifts[weekDay] || !category.shifts[weekDay][j]"
                class="wg-row"  
              >
                <button class="small" @click="addShift(weekDay, j)">
                  {{ $anm22.strLang(lang, 'Add', 'Aggiungi') }}
                </button>
              </div>
              <div v-else class="wg-row" style="flex-wrap:nowrap;align-items:center;">
                <img 
                    class="com-anm22-app-img-fixed-height-m" 
                    style="cursor:pointer;margin-right:10px;" 
                    :src="$anm22.icons.getWorldIcon('deleteBlack')" 
                    @click="removeShift(weekDay, j)">
                <div class="display-flex" style="flex-direction:column;margin-right:5px;">
                  <div class="com-anm22-app-text-m">
                    {{ $anm22.strLang(lang, 'Orders limit', 'Limite ordini') }}
                  </div>
                  <div class="vertical-height-div" style="height:2px;"></div>
                  <input 
                      style="width:110px;"
                      type="number" 
                      v-model="category.shifts[weekDay][j].limit_orders">
                </div>
                <div class="display-flex" style="flex-direction:column;margin-right:5px;">
                  <div class="com-anm22-app-text-m">
                    {{ $anm22.strLang(lang, 'Products limit', 'Limite prodotti') }}
                  </div>
                  <div class="vertical-height-div" style="height:2px;"></div>
                  <input 
                      style="width:110px;"
                      type="number" 
                      v-model="category.shifts[weekDay][j].limit_products">
                </div>
              </div>
            </div>
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
        </div>
      </div>
      <div class="vertical-height-div" style="height:10px;"></div>
      <div class="wg-row">
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="com-anm22-app-text-l" style="padding:0 2px;">
            {{ $anm22.strLang(lang, 'Order printer', 'Stampa comande') }}
          </div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <select class="com-anm22-app-select" v-model="category.idPrinter" style="max-width:100%;">
            <option :value="0">--</option>
            <option 
                v-for="(p,i) in printers"
                :key="'printer-'+i"
                :value="p.idPrinter">
              {{ p.name }}
            </option>
          </select>
        </div>
      </div>
    </template>
    <div class="vertical-height-div" style="height:10px;"></div>
    <div class="wg-row">
      <input 
          type="button" 
          :value="$anm22.strLang(lang, 'Save', 'Salva')" 
          @click="save">
    </div>
    <div class="vertical-height-div" style="height:10px;"></div>
    <div class="wg-row">
      <input 
          type="button"
          class="com-anm22-button-red" 
          :value="$anm22.strLang(lang, 'Delete', 'Elimina')" 
          @click="deleteCategory">
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    categoryRef: Object
  },
  data() {
    return {
      category: {...this.categoryRef},
      languages: ['it', 'en', 'de', 'fr', 'es', 'ru'],
      colors: [
        '#F4511E',
        '#E53935',
        '#D81B60',
        '#8E24AA',
        '#3949AB',
        '#2196f3',
        '#00897B',
        '#43A047',
        '#546E7A',
        '#000',
      ],
      icons: [],
      showVariationsDialog: false,
      variation: {},
      showIconDialog: false,
      icon: null,
      showColorDialog: false,
      color: null,
      varError: ''
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      lang: state => state.lang,
      licenseSelected: state => state.licenseSelected,
      windowWidth: state => state.windowWidth,
      windowHeight: state => state.windowHeight,
      isOffline: state => state.offline.isOffline
    }),
    license() {
      return this.$store.getters['foodLicenses/getByHash'](this.licenseSelected);
    },
    categories() {
      return this.$store.getters['foodCategories/getByLicense'](this.license.id).filter(c => !c.deleted);
    },
    printers() {
      return this.$store.getters['foodPrinters/getByLicense'](this.license.id).filter(p => p.printMode.list);
    },
  },
  methods: {
    addShift(weekDay, index) {
      const licenseShift = this.license.shifts[weekDay][index];
      const shift = {...licenseShift};
      shift.limit_orders = 0;
      shift.limit_products = 0;
      // get last of day if present
      if(!this.category.shifts[weekDay]) {
        this.$set(this.category.shifts, weekDay, []);
      }
      this.$set(this.category.shifts[weekDay], index, shift);
    },
    removeShift(weekDay, index) {
      this.category.shifts[weekDay].splice(index, 1);
      if(this.category.shifts[weekDay].length === 0) {
        this.category.shifts.splice(weekDay,1);
      }
    },
    async save() {
      const mode = Number.isInteger(this.category.id) ? 'edit' : 'new';
      try {
        const response = await this.$http.post('inventory/category', {
          category: this.category
        });
        this.$store.dispatch('foodCategories/update', {
          vlf: this.$vlf('foodCategories'), objs: response.data.categories
        })
      } catch(e) {
        // Check ordering
        if(mode === 'edit') {
          if(this.categoryRef.parent && this.categoryRef.parent !== this.category.parent) {
            this.checkOrdering();
          }
        } else {
          this.checkOrdering();
        }
        // Dati aggregati o derivati
        this.category.langName = this.category['name' + this.lang] || this.category.name;
        this.category.img = '';
        this.category.icon = this.category.iconName ? 'utilities/img/gastronomy-white-svg/' + this.category.iconName + '.svg' : '';
        this.category.color = this.category.colorString || '#2196F3';
        await Promise.all([
          this.$store.dispatch('foodCategories/update', {
            vlf: this.$vlf('foodCategories'), objs: [ this.category ]
          }),
          this.$store.dispatch('offline/saveSyncTuple', {
            _vue: this,
            _class: "FoodCategory",
            _table: "foodCategories",
            mode: mode,
            type: 'obj',
            obj: this.category
          })
        ]);
      } finally {
        this.$anm22.eventBus.$emit('wg-modal-close');
      }
    },
    async deleteCategory() {
      try {
        if(!Number.isInteger(this.category.id)) {
          throw new Error('Local object');
        }
        const response = await this.$http.post('inventory/category-delete', {
          category: this.category
        });
        if(response.data.success) {
          this.category.deleted = true;
          this.$store.dispatch('foodCategories/update', {
            vlf: this.$vlf('foodCategories'), objs: [this.category]
          });
        } else {}
      } catch(e) {
        this.category.deleted = true;
        await Promise.all([
          this.$store.dispatch('foodCategories/update', {
            vlf: this.$vlf('foodCategories'), objs: [ this.category ]
          }),
          this.$store.dispatch('offline/saveSyncTuple', {
            _vue: this,
            _class: "FoodCategory",
            _table: "foodCategories",
            mode: 'edit',
            type: 'obj',
            obj: this.category
          })
        ]);
      } finally {
        this.$anm22.eventBus.$emit('wg-modal-close');
      }
    },
    async addVariation() {
      this.varError = '';
      if(!this.variation.it && !this.variation.en && !this.variation.de && !this.variation.fr
            && !this.variation.es && !this.variation.ru
      ) {
        this.varError = this.$anm22.strLang(
          this.lang,
          "At least one language must be provided",
          "Almeno una lingua deve essere compilata"
        );
        return;
      }
      if(!this.variation.price && this.variation.price !== 0) {
        this.varError = this.$anm22.strLang(
          this.lang,
          "Variation price not valid",
          "Prezzo della variazione non valido"
        );
        return;
      }
      // if(this.variation.price < 0) {
      //   this.varError = this.$anm22.strLang(
      //     this.lang,
      //     "Variation price cannot be negative",
      //     "Il prezzo della variazione non può essere negativo"
      //   );
      //   return;
      // }
      try {
        if(!Number.isInteger(this.categoryRef.id)) {
          throw new Error('Local object');
        }
        const response = await this.$http.post('inventory/add-var', {
          categoryId: this.categoryRef.id,
          variation: this.variation
        });
        this.$store.dispatch('foodCategories/update', {
          vlf: this.$vlf('foodCategories'), objs: response.data.categories
        });
      } catch(e) {
        this.category.variations.push(JSON.parse(JSON.stringify(this.variation)));
        this.$store.dispatch('foodCategories/update', {
          vlf: this.$vlf('foodCategories'), objs: [ this.category ]
        }),
        this.$store.dispatch('offline/saveSyncTuple', {
          _vue: this,
          _class: "FoodCategory",
          _table: "foodCategories",
          mode: 'edit',
          type: 'obj',
          obj: this.category
        })
      } finally {
        this.variation = {};
      }
    },
    async deleteVariation(index) {
      try {
        if(!Number.isInteger(this.categoryRef.id)) {
          throw new Error('Local object');
        }
        const response = await this.$http.post('inventory/delete-var', {
          categoryId: this.categoryRef.id,
          index
        });
        this.$store.dispatch('foodCategories/update', {
          vlf: this.$vlf('foodCategories'), objs: response.data.categories
        });
      } catch(e) {
        this.category.variations.splice(index, 1);
        this.$store.dispatch('foodCategories/update', {
          vlf: this.$vlf('foodCategories'), objs: [ this.category ]
        }),
        this.$store.dispatch('offline/saveSyncTuple', {
          _vue: this,
          _class: "FoodCategory",
          _table: "foodCategories",
          mode: 'edit',
          type: 'obj',
          obj: this.category
        })
      }
    },
    openIconModal() {
      // Load icons if not loaded
      if(this.icons.length === 0) {
        this.$http.get('inventory/icons')
          .then(response => {
            this.icons = response.data.icons;
          });
      }
      if(this.category.iconName) {
        this.icon = this.category.iconName;
      }
      this.showIconDialog = true;
    },
    async setIcon() {
      try {
        if(!Number.isInteger(this.categoryRef.id)) {
          throw new Error('Local object');
        }
        const response = await this.$http.post('inventory/color', {
          categoryId: this.categoryRef.id,
          icon: this.icon
        });
        this.$store.dispatch('foodCategories/update', {
          vlf: this.$vlf('foodCategories'), objs: response.data.categories
        });
      } catch(e) {
        this.category.iconName = this.icon;
        this.$store.dispatch('foodCategories/update', {
          vlf: this.$vlf('foodCategories'), objs: [ this.category ]
        }),
        this.$store.dispatch('offline/saveSyncTuple', {
          _vue: this,
          _class: "FoodCategory",
          _table: "foodCategories",
          mode: 'edit',
          type: 'obj',
          obj: this.category
        })
      } finally {
        this.showIconDialog = false;
      }
    },
    openColorModal() {
      if(this.categoryRef.colorString) {
        this.color = this.categoryRef.colorString;
      }
      this.showColorDialog = true;
    },
    async setColor() {
      try {
        if(!Number.isInteger(this.categoryRef.id)) {
          throw new Error('Local object');
        }
        const response = await this.$http.post('inventory/color', {
          categoryId: this.categoryRef.id,
          color: this.color
        });
        this.$store.dispatch('foodCategories/update', {
          vlf: this.$vlf('foodCategories'), objs: response.data.categories
        });
      } catch(e) {
        this.category.colorString = this.color;
        this.$store.dispatch('foodCategories/update', {
          vlf: this.$vlf('foodCategories'), objs: [ this.category ]
        }),
        this.$store.dispatch('offline/saveSyncTuple', {
          _vue: this,
          _class: "FoodCategory",
          _table: "foodCategories",
          mode: 'edit',
          type: 'obj',
          obj: this.category
        })
      } finally {
        this.showColorDialog = false;
      }
    },
    checkOrdering() {
      const otherSubCategories = this.category.parent
          ? this.categories.filter(c => c.parent && c.parent === this.category.parent)
          : [];
      let lastIndex = 0;
      if(otherSubCategories.length > 0) {
        otherSubCategories.forEach(c => {
          if(c.ordering > lastIndex) {
            lastIndex = c.ordering;
          }
        })
      }
      this.category.ordering = ++lastIndex;
    }
  },
}
</script>

<style lang="scss" scoped>
.label-input-radio {
  display: block;
  height: 30px;
  width: 30px;
  border: 1px solid #bbb;
  border-radius: 4px;
  font-size: 18px;
  padding: 6px;
  cursor: pointer;
}
.icon-div {
  border: 3px solid #ddd;
  background-position: center center;
  background-size: cover;
  cursor: pointer;
  border-radius: 5px;
  background-color: #fff;
  padding: 5px;
  box-sizing: border-box;
  margin: 5px;
  &:hover, &.selected {
    border-color: #2196F3;
  }
}
.color-div {
  border-radius: 5px;
  justify-content: center;
  cursor: pointer;
  margin-bottom: 10px;
  &:hover, &.selected {
    background-color: #ddd;
  }
  div {
    height: 15px;
    width: 60px;
    margin: 10px 0;
    border-radius: 10px;
    border: 1px solid #ccc;
  }
}
</style>
